"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrefixedQuiltWrapperBundleId = void 0;
const enums_1 = require("@aurora/shared-types/overrides/enums");
function buildBundleId(tenantId, wrapperId, locale, lastModified) {
    return `${tenantId}:${wrapperId}:${locale ? `${locale}-` : ''}${lastModified !== null && lastModified !== void 0 ? lastModified : 0}`;
}
/**
 * Builds an identifier to be used as an Apollo cache key for Quilt Wrapper assets
 * @param tenantId tenant id from tenant context
 * @param wrapperId quilt wrapper identifier
 * @param locale the locale identifier
 * @param lastModified last modified timestamp
 */
function buildPrefixedQuiltWrapperBundleId(tenantId, wrapperId, locale, lastModified) {
    return `${enums_1.CachedAssetType.WRAPPER}:${buildBundleId(tenantId, wrapperId, locale, lastModified)}`;
}
exports.buildPrefixedQuiltWrapperBundleId = buildPrefixedQuiltWrapperBundleId;
//# sourceMappingURL=ApolloQuiltWrapperCacheHelper.js.map